exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrapper[data-v-3ec1e03e]{position:relative}.wrapper .add[data-v-3ec1e03e]{position:absolute;bottom:-17px;z-index:100;left:calc(50% - 23px)}.header[data-v-3ec1e03e]{margin-bottom:20px}.header>[data-v-3ec1e03e]{display:inline-block;vertical-align:middle;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ec1e03e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Contacts.vue
// module id = 414
// module chunks = 0